import { useState } from 'react'

import { isDirtyForm } from '../../../../utils/formHelpers'

export function useCloseConfirm({ getIsDirty = isDirtyForm, onClose }) {
  const [isCloseConfirm, setCloseConfirm] = useState(false)

  function handleClose(params) {
    if (getIsDirty(params)) {
      setCloseConfirm(true)

      return
    }

    onClose()
  }

  function handleCloseConfirmation() {
    setCloseConfirm(false)
  }

  return {
    handleClose,
    handleCloseConfirmation,
    isCloseConfirm,
    setCloseConfirm,
  }
}
